// extracted by mini-css-extract-plugin
export var linkText = "_nw-0";